import { Col } from "@commonlibs";
import styled, { css } from "styled-components";

export const DataTableRoot = styled(Col)(
    ({ theme }) => css`
        background: ${theme.palette.white};
        .TableNoRowsOverlay {
            min-height: 12rem;
            position: unset;
        }
        .TableCell {
            .Skeleton {
                border-radius: 0;
            }
        }
    `,
);
